import React from 'react'
import ReactDOM from 'react-dom/client'
import {NewsroomSearch} from "./components/Newsroom/NewsroomSearch.jsx"
import {NewsroomFilter} from "./components/Newsroom/NewsroomFilter.jsx"

const initFilter = () => {
    const element = document.querySelector('.solr-newsroom-filter')

    if (element === null) {
        return
    }

    const root = ReactDOM.createRoot(element)
    root.render(
        React.createElement(React.StrictMode, null,
            React.createElement(NewsroomFilter)
        )
    )
}

const initResults = () => {
    const element = document.querySelector('.solr-newsroom-results')

    if (element === null) {
        return
    }

    const root = ReactDOM.createRoot(element)
    root.render(
        React.createElement(React.StrictMode, null,
            React.createElement(NewsroomSearch)
        )
    )
}

window.onload = () => {
    initFilter()
    initResults()
}
